export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  garages: [],
  rental: {
    tower_id: null,
    unit_id: null,
    garage_id: null,
    guest_name: null,
    guest_id: null,
    guest_email: null,
    phone: null,
    status: true
  },
  rentals: [],
  entity: 'rental',
  entities: 'rentals',
  dwellerRentalUnits: [],
  dwellerTowers: [],
  optionTowers: [],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  config: {
    sideBySide: true,
    useCurrent: false,
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  prefixRouter: 'dweller.rental.unit'
})



// WEBPACK FOOTER //
// ./src/app/dweller/rental/resources/data.js